"use client";

import type React from "react";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert,
  TablePagination,
  InputAdornment,
  Grid,
  Card,
  CardContent,
  Chip,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Search as SearchIcon,
  Add as AddIcon,
  Inventory as InventoryIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

import {
  Grade as GradeIcon,
  Refresh as RefreshIcon,
  Percent as PercentIcon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { baseURL, config, requestID } from "../../../common/utils";
import { IonContent, IonPage } from "@ionic/react";
import { getTlocations_production_centre } from "../../../api/stock-transfer/stock-transfer";

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 12,
  boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
  border: "1px solid rgba(0,0,0,0.06)",
}));

const HeaderCard = styled(Box)(({ theme }) => ({
  background: "#f8fafc",
  border: "1px solid #e2e8f0",
  padding: theme.spacing(3),
  borderRadius: "12px 12px 0 0",
}));

const StyledModal = styled(Modal)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const ModalContent = styled(Box)(({ theme }) => ({
  backgroundColor: "white",
  borderRadius: 12,
  padding: theme.spacing(4),
  maxWidth: 600,
  width: "90%",
  maxHeight: "90vh",
  overflowY: "auto",
  outline: "none",
  boxShadow:
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
}));

interface Product {
  product_id: string;
  name: string;
  type: string;
  qty: number;
  price: number;
  minSalePrice: number;
  purchasePrice: number;
  stockControlled: string;
  grade_letter: string;
  category_name: string;
  category_id: string;
  instocks: number;
  last_updated: string;
  totalQtyPosted: number;
  reorder_qty: string;
  category:string;
}

 
const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: 12,
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  },
}))

const StatsCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2.5),
  textAlign: "center",
  borderRadius: 8,
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
}))

const GradeChip = styled(Chip)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "0.875rem",
  height: 32,
  borderRadius: 8,
}))

interface Grade {
  grade_id: string
  grade_letter: string
  grade_value: number
}

const ProductSetupPage_all_branch: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState({ table: false, submit: false });
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error",
  });
  const [formData, setFormData] = useState({
    last_updated: "",
    name: "",
    type: "",
    stockControlled: "",
    price: "",
    qty: 0,
    instocks: 0,
    minSalePrice: "",
    purchasePrice: "",
    grade_letter: "",
    category_name: "",
    category_id: "",
    productCategory: "",
    product_id: "",
    reorder_qty:""
  });
  const [grades, setGrades] = useState<any[]>([]);
  const [categories, setCategories] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [productToDelete, setProductToDelete] = useState<Product | null>(null);
  const [deleteScope, setDeleteScope] = useState("this_branch");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [branches, setBranches] = useState<any[]>([]);
  const [selectedBranch, setSelectedBranch] = useState<string | null>(null);

  useEffect(() => {
    fetchBranches();
    fetchGrades();
    fetchCategories();
  }, []);

  const fetchBranches = async () => {
    try {
       const response = await getTlocations_production_centre()
      console.log(response)
      setBranches(response.data.data || [])

      // const res = await axios.post(`${baseURL}auth/getTlocations_production_centre`, { requestID: requestID() }, config);
      // setBranches(res.data.data || []);
    } catch (error) {
      console.error("Failed to fetch branches", error);
      setToast({
        open: true,
        message: "Failed to fetch branches",
        severity: "error",
      });
    }
  };

  const fetchGrades = async () => {
    const payload = { requestID: requestID() };
    try {
      const res = await axios.post(
        `${baseURL}warehouses/getAll_customer_product_grade`,
        payload,
        config
      );
      setGrades(res.data.data || []);
    } catch {
      console.error("Failed to load grades");
    }
  };

  
  const fetchProductGrades = async (product_id: string) => {
    const payload = { requestID: requestID() ,
        product_id: product_id,
    };

    console.log("Fetching product grades for:", payload);
    try {
      const res = await axios.post(
        `${baseURL}warehouses/getProductGrades`,
        payload,
        config
      );
      setProductGrade(res.data.data || []);
      console.log("Fetched product grades:", productGrades);
    } catch {
      console.error("Failed to load grades");
    }
  };
  

  const fetchCategories = async () => {
    const payload = { requestID: requestID() };
    try {
      const res = await axios.post(
        `${baseURL}warehouses/getCategories`,
        payload,
        config
      );
      setCategories(res.data.data || []);
    } catch {
      console.error("Failed to load categories");
    }
  };

  const [productGrades, setProductGrade]= useState([]);
const [loadingn, setLoadingn] = useState(false);

  const fetchProductSetup = async (branch_id: string) => {
    if (!branch_id) {
      setProducts([]);
      return;
    }
    setLoadingn(true); // start loading

    setProducts([]);
      console.log('selected branch '+ branch_id)

    const payload = { requestID: requestID(), branch_id: branch_id };
    try {
      //   setLoading((prev) => ({ ...prev, table: true }))
      const res = await axios.post(
        `${baseURL}Warehouses/getAllProducts_byBranch_sent`,
        payload,
        config
      );
      console.log("Product response:", res);
    setLoadingn(false); // end loading

      setProducts(res.data.data || []);
    } catch {
          setLoadingn(false); // end loading

      setToast({
        open: true,
        message: "Error fetching products",
        severity: "error",
      });
    } finally {
          setLoadingn(false); // start loading

      // setLoading((prev) => ({ ...prev, table: false }))
    }
  };

useEffect(() => {
  if (Array.isArray(products)) {
    const filtered = products.filter((prod) =>
      prod.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredProducts(filtered);
  } else {
    setFilteredProducts([]); // fallback if products is not an array
  }
}, [searchTerm, products]);

  const resetForm = () => {
    setFormData({
      last_updated: "",
      name: "",
      type: "",
      stockControlled: "",
      price: "",
      qty: 0,
      instocks: 0,
      minSalePrice: "",
      purchasePrice: "",
      grade_letter: "",
      category_name: "",
      category_id: "",
      productCategory: "",
      product_id: "",
      reorder_qty:""
    });
  };

    const handleSubmitGrade = async (e: React.FormEvent) => {
             //   handleCloseGrade()

      e.preventDefault()
      const payload: any = {
        requestID: requestID(),
        grade_letter: gradeName.trim().toUpperCase(),
        grade_value: Number.parseFloat(gradeValue),
        product_id: selectedProd
      }
  const url =`${baseURL}warehouses/create_customer_product_grade_product_id`
  
      // const url = selectedGrade
      //   ? `${baseURL}warehouses/update_customer_product_grade`
      //   : `${baseURL}warehouses/create_customer_product_grade_product_id`
  
      if (selectedGrade) {
        payload.grade_id = selectedGrade.grade_id
      }
  
      try {
        setSubmitLoading(true)
        const res = await axios.post(url, payload, config)
  console.log(res);
     fetchProductGrades(selectedProd)
        if (res.data.status === "true") {
          setToast({
            open: true,
            message: selectedGrade ? "Grade updated successfully!" : "Grade created successfully!",
            severity: "success",
          })
          
       
          handleCloseGrade()
          fetchGrades()
        } else {
          throw new Error(res.data.message || "Operation failed")
        }
      } catch (err: any) {
        setToast({ open: true, message: err.message, severity: "error" })
      } finally {
        setSubmitLoading(false)
      }
    }


  const handleOpen = () => {
    resetForm();
    setSelectedProduct(null);
    setOpen(true);
  };

  const handleClose = () => {
    console.log("Modal closed");
    setOpen(false);
    resetForm();
    setToast({ ...toast, open: false });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const updated: any = { ...formData, [name]: value };

    if (
      ["price", "minSalePrice", "purchasePrice", "qty", "instocks"].includes(
        name
      )
    ) {
      updated[name] = Number.parseFloat(value) || 0;
    }

    setFormData(updated);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const payload = {
      requestID: requestID(),
      ...formData,
      product_id: formData.product_id || null,
      branch_id: selectedBranch,
    };

    try {
      setLoading((prev) => ({ ...prev, submit: true }));
      const endpoint = formData.product_id
        ? `${baseURL}warehouses/updateProduct_sent`
        : `${baseURL}warehouses/addProduct_pos_sent`;
      const res = await axios.post(endpoint, payload, config);
      console.log("Product response:", res);

      if (res.data.status === "success") {
        setToast({
          open: true,
          message: "Product saved successfully",
          severity: "success",
        });
        handleClose();
        if (selectedBranch) {
          fetchProductSetup(selectedBranch);
        }
      } else {
        throw new Error();
      }
    } catch (err) {
      console.error(err);
      setToast({
        open: true,
        message: "Error saving product",
        severity: "error",
      });
    } finally {
      setLoading((prev) => ({ ...prev, submit: false }));
    }
  };

  const handleOpenDeleteDialog = (product: Product) => {
    setProductToDelete(product);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setProductToDelete(null);
    setDeleteScope("this_branch");
  };

  const handleConfirmDelete = async () => {
    if (!productToDelete) return;

    setDeleteLoading(true);
    const payload = {
      requestID: requestID(),
      product_id: productToDelete.product_id,
      scope: deleteScope,
      branch_id: selectedBranch,
    };

    try {
      const res = await axios.post(
        `${baseURL}warehouses/deleteProduct`,
        payload,
        config
      );

      if (res.data.status === "true" || res.data.status === "success") {
        setToast({
          open: true,
          message: "Product deleted successfully",
          severity: "success",
        });
        handleCloseDeleteDialog();
        if (selectedBranch) {
          fetchProductSetup(selectedBranch);
        }
      } else {
        throw new Error(res.data.message || "Deletion failed");
      }
    } catch (err: any) {
      console.error(err);
      setToast({
        open: true,
        message: err.message || "An error occurred during deletion",
        severity: "error",
      });
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleEdit = (prod: Product) => {
    setSelectedProduct(prod);
    console.log(prod);
    setFormData({
      ...prod,
      last_updated: prod.last_updated || '',
      name: prod.name || '',
      type: prod.type || '',
      stockControlled: prod.stockControlled || '',
      price: prod.price.toString() || '',
      qty: Number.parseFloat(prod.qty.toString()) || 0,
      instocks: Number.parseInt(prod.instocks.toString()) || 0,
      minSalePrice: prod.minSalePrice.toString() || '',
      purchasePrice: prod.purchasePrice.toString() || '',
      grade_letter: prod.grade_letter || '',
      category_name: prod.category_name || '',
      category_id: prod.category_id || '',
      productCategory: prod.category || '',
      product_id: prod.product_id || '',
      reorder_qty: prod.reorder_qty || "",
      category: prod.category || ''
    });

    console.log(formData);
    setOpen(true);
  };

  const handleCloseGrade = () => {
    setOpenGrade(false);
    setGradeName("");
    setGradeValue("");
    setSelectedGrade(null);
  };

  const getGradeColor = (value: number) => {
    if (value >= 0.8) return "#10b981"; // Green for high grades
    if (value >= 0.6) return "#f59e0b"; // Yellow for medium grades
    if (value >= 0.4) return "#ef4444"; // Red for low grades
    return "#6b7280"; // Gray for very low grades
  };

  const getStatusColor = (instocks: number) => {
    return instocks === 1 ? "success" : "error";
  };

  const getTypeColor = (type: string) => {
    return type === "finished" ? "primary" : "secondary";
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(amount);
  };

  const [gradeName, setGradeName] = useState("");
  const [selectedProd, setSelectedProd] = useState("");
  const [selectedProdName, setSelectedProdName] = useState("");

  const [gradeValue, setGradeValue] = useState("");
  const [selectedGrade, setSelectedGrade] = useState<Grade | null>(null);
  const [openGrade, setOpenGrade] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false);

  const alphabet = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
  );

  return (
    <IonPage>
      <IonContent>
        <Container maxWidth="xl" sx={{ py: 3 }}>
          <StyledCard sx={{ mb: 3, p: 3 }}>
            <FormControl fullWidth>
              <InputLabel>Select Branch</InputLabel>
              <Select
                value={selectedBranch || ""}
                onChange={(e) => {
                  setSelectedBranch(e.target.value as string);
                  fetchProductSetup(e.target.value as string);
                }}
                label="Select Branch"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {branches.map((branch) => (
                  <MenuItem key={branch.branch_id} value={branch.branch_id}>
                    {branch.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </StyledCard>
          
          {selectedBranch && (
            <>
              {loadingn ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                  <CircularProgress size={40} color="primary" />
                </Box>
              ) : (
                <>
                  <StyledCard sx={{ mb: 3 }}>
                    <HeaderCard>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Box>
                          <Typography
                            variant="h5"
                            fontWeight="600"
                            color="#1e293b"
                            sx={{ display: "flex", alignItems: "center", gap: 1 }}
                          >
                            <InventoryIcon />
                            Product Setup
                          </Typography>
                          <Typography variant="body2" color="#64748b" sx={{ mt: 0.5 }}>
                            Manage your product inventory and pricing
                          </Typography>
                        </Box>
                        <Button
                          variant="contained"
                          startIcon={<AddIcon />}
                          onClick={handleOpen}
                          sx={{
                            bgcolor: "#1e293b",
                            "&:hover": { bgcolor: "#334155" },
                            textTransform: "none",
                            px: 3,
                            py: 1.5,
                          }}
                        >
                          Add Product
                        </Button>
                      </Box>
                    </HeaderCard>
                  </StyledCard>

                  <StyledCard>
                    <CardContent sx={{ p: 3 }}>
                      <TextField
                        placeholder="Search products by name..."
                        fullWidth
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon color="action" />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ mb: 3 }}
                      />

                      {loading.table ? (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                          <CircularProgress size={40} />
                        </Box>
                      ) : (
                        <>
                          <TableContainer
                            component={Paper}
                            sx={{ borderRadius: 2, border: "1px solid #e2e8f0" }}
                          >
                            <Table>
                              <TableHead>
                                <TableRow sx={{ bgcolor: "#f8fafc" }}>
                                  <TableCell sx={{ fontWeight: "600", color: "#374151" }}>
                                    Product
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "600", color: "#374151" }}>
                                    Type
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "600", color: "#374151" }}>
                                    Stock
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "600", color: "#374151" }}>
                                    Pricing
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "600", color: "#374151" }}>
                                    Status
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "600", color: "#374151" }}>
                                    Category
                                  </TableCell>
                                  <TableCell align="right" sx={{ fontWeight: "600", color: "#374151" }}>
                                    Actions
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {filteredProducts
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((prod, i) => (
                                    <TableRow key={i} hover>
                                      <TableCell>
                                        <Box>
                                          <Typography
                                            variant="body1"
                                            fontWeight="500"
                                            color="#1e293b"
                                          >
                                            {prod.name}
                                          </Typography>
                                          <Typography variant="caption" color="#64748b">
                                            Product ID: {prod.product_id}
                                          </Typography>
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        <Chip
                                          label={prod.type}
                                          size="small"
                                          color={getTypeColor(prod.type) as any}
                                          sx={{ textTransform: "capitalize" }}
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <Box>
                                          <Typography variant="body2" fontWeight="500">
                                            Qty: {prod.qty}
                                          </Typography>
                                          <Typography variant="caption" color="#64748b">
                                            Posted: {prod.totalQtyPosted}
                                          </Typography>
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        <Box>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#1e293b"
                                          >
                                            {formatCurrency(prod.price)}
                                          </Typography>
                                          <Typography variant="caption" color="#64748b">
                                            Min: {formatCurrency(prod.minSalePrice)}
                                          </Typography>
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        <Chip
                                          label={
                                            Number.parseInt(
                                              prod.instocks.toString()
                                            ) === 1
                                              ? "Available"
                                              : "Unavailable"
                                          }
                                          size="small"
                                          color={
                                            getStatusColor(
                                              Number.parseInt(prod.instocks.toString())
                                            ) as any
                                          }
                                        />
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant="body2" color="#374151">
                                          {prod.category_name || prod.category}
                                        </Typography>
                                      </TableCell>
                                      <TableCell align="right">
                                        <Stack
                                          direction="row"
                                          spacing={1}
                                          justifyContent="flex-end"
                                        >
                                          <IconButton
                                            size="small"
                                            onClick={() => {
                                              setOpenGrade(true);
                                              setSelectedProd(prod.product_id);
                                              fetchProductGrades(prod.product_id);
                                              setSelectedProdName(prod.name);
                                            }}
                                            sx={{
                                              color: "#64748b",
                                              "&:hover": { bgcolor: "#f1f5f9" },
                                            }}
                                          >
                                            <AddIcon fontSize="small" /> Grade
                                          </IconButton>

                                          <IconButton
                                            size="small"
                                            onClick={() => handleEdit(prod)}
                                            sx={{
                                              color: "#64748b",
                                              "&:hover": { bgcolor: "#f1f5f9" },
                                            }}
                                          >
                                            <EditIcon fontSize="small" />
                                          </IconButton>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenDeleteDialog(prod)}
                                            sx={{
                                              color: "#ef4444",
                                              "&:hover": { bgcolor: "#fef2f2" },
                                            }}
                                          >
                                            <DeleteIcon fontSize="small" />
                                          </IconButton>
                                        </Stack>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>
                          </TableContainer>

                          <TablePagination
                            component="div"
                            count={filteredProducts.length}
                            page={page}
                            onPageChange={(e, newPage) => setPage(newPage)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(e) => {
                              setRowsPerPage(Number.parseInt(e.target.value, 10));
                              setPage(0);
                            }}
                            sx={{ borderTop: "1px solid #e2e8f0", mt: 2 }}
                          />
                        </>
                      )}
                    </CardContent>
                  </StyledCard>
                </>
              )}
            </>
          )}
          <StyledModal open={open} onClose={handleClose}>
            <ModalContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Typography variant="h6" fontWeight="600" color="#1e293b">
                  {selectedProduct ? "Edit Product" : "Add New Product"}
                </Typography>
                <IconButton onClick={handleClose} sx={{ color: "#64748b" }}>
                  <CloseIcon />
                </IconButton>
              </Box>

              <Box component="form" onSubmit={handleSubmit}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Product Name"
                      name="name"
                      fullWidth
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Selling Price"
                      name="price"
                      fullWidth
                      type="number"
                      required
                      value={formData.price}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">₦</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Cost Price"
                      name="purchasePrice"
                      fullWidth
                      type="number"
                      value={formData.purchasePrice}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">₦</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Min Sale Price"
                      name="minSalePrice"
                      fullWidth
                      type="number"
                      value={formData.minSalePrice}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">₦</InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Quantity"
                      name="qty"
                      fullWidth
                      type="number"
                      value={formData.qty}
                      onChange={handleChange}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Stock Control</InputLabel>
                      <Select
                        name="stockControlled"
                        label="Stock Control"
                        value={formData.stockControlled}
                        onChange={handleChange}
                      >
                        <MenuItem value="stock_controlled">Controlled</MenuItem>
                        <MenuItem value="not_stock_controlled">
                          Non-Controlled
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="instocks"
                        value={formData.instocks}
                        onChange={handleChange}
                        label="Status"
                      >
                        <MenuItem value={1}>Available</MenuItem>
                        <MenuItem value={0}>Unavailable</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Category {formData.category}</InputLabel>
                      <Select
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        label="Category"
                      >
                        {categories.map((cat) => (
                          <MenuItem key={cat.id} value={cat.category_id}>
                            {cat.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Re-Order Quantity"
                      name="reorder_qty"
                      fullWidth
                      type="number"
                      value={formData.reorder_qty}
                      onChange={handleChange}
                    />
                  </Grid>
                </Grid>

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  size="large"
                  disabled={loading.submit}
                  sx={{
                    mt: 4,
                    py: 1.5,
                    bgcolor: "#1e293b",
                    "&:hover": { bgcolor: "#334155" },
                    textTransform: "none",
                    fontWeight: 600,
                  }}
                >
                  {loading.submit ? (
                    <>
                      <CircularProgress
                        size={20}
                        sx={{ mr: 1, color: "white" }}
                      />
                      Saving...
                    </>
                  ) : (
                    "Save Product"
                  )}
                </Button>
              </Box>
            </ModalContent>
          </StyledModal>

          <StyledDialog
            open={openGrade}
            onClose={handleCloseGrade}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="600">
                  {selectedGrade ? "Edit Grade" : "Add New Grade"}
                  {` for ${selectedProdName}`}
                </Typography>
                <IconButton onClick={handleCloseGrade} sx={{ color: "#64748b" }}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
              <Box component="form" onSubmit={handleSubmitGrade}>
                <FormControl fullWidth required sx={{ mb: 3 }}>
                  <InputLabel id="grade-letter-label">Grade Letter</InputLabel>
                  <Select
                    labelId="grade-letter-label"
                    value={gradeName}
                    name="gradeName"
                    onChange={(e) => setGradeName(e.target.value)}
                    label="Grade Letter"
                    startAdornment={
                      <InputAdornment position="start">
                        <GradeIcon color="action" />
                      </InputAdornment>
                    }
                  >
                    {alphabet.map((letter) => (
                      <MenuItem key={letter} value={letter}>
                        {letter}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  fullWidth
                  label="Grade Value"
                  type="number"
                  name="gradeValue"
                  value={gradeValue}
                  onChange={(e) => setGradeValue(e.target.value)}
                  required
                  placeholder="e.g., 0.85 for 85%"
                  inputProps={{ min: 0, max: 1, step: 0.01 }}
                  helperText="Enter a decimal value between 0 and 1 (e.g., 0.85 for 85%)"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PercentIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                />
                {gradeValue && (
                  <Box
                    sx={{ mt: 2, p: 2, bgcolor: "#f8fafc", borderRadius: 2 }}
                  >
                    <Typography variant="body2" color="#64748b" sx={{ mb: 1 }}>
                      Preview:
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <GradeChip
                        label={gradeName || "?"}
                        sx={{
                          bgcolor: getGradeColor(
                            Number.parseFloat(gradeValue) || 0
                          ),
                          color: "white",
                        }}
                      />
                      <Typography variant="body1" fontWeight="500">
                        {(Number.parseFloat(gradeValue) * 100 || 0).toFixed(0)}%
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={handleCloseGrade}
                sx={{ color: "#64748b", textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmitGrade}
                variant="contained"
                disabled={submitLoading || !gradeName.trim() || !gradeValue}
                startIcon={
                  submitLoading ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : null
                }
                sx={{
                  bgcolor: "#1e293b",
                  "&:hover": { bgcolor: "#334155" },
                  textTransform: "none",
                  px: 3,
                }}
              >
                {submitLoading
                  ? "Saving..."
                  : selectedGrade
                  ? "Update Grade"
                  : "Create Grade"}
              </Button>
            </DialogActions>

            <TableContainer
              component={Paper}
              sx={{
                mt: 3,
                borderRadius: 2,
                boxShadow: 2,
                '& .MuiTableCell-root': {
                  padding: '8px 16px',
                },
              }}
            >
              <Table size="small">
                <TableHead
                  sx={{
                    backgroundColor: "#f1f5f9",
                    '& .MuiTableCell-root': {
                      padding: '8px 16px',
                      fontWeight: 600,
                    },
                  }}
                >
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Grade Letter</TableCell>
                    <TableCell>Grade Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {productGrades.length > 0 ? (
                    productGrades.map((grade: any, index) => (
                      <TableRow key={grade.grade_id} hover>
                        <TableCell>
                          <Chip
                            label={index + 1}
                            size="small"
                            sx={{
                              backgroundColor: "#e2e8f0",
                              color: "#334155",
                              fontWeight: 500,
                              height: '24px',
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight={600}>
                            {grade.grade_letter}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2">
                            {grade.grade_value ? `${(grade.grade_value * 100).toFixed(0)}%` : "No value"}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} align="center" sx={{ py: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                          No grades available.
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </StyledDialog>

          <StyledDialog
            open={openDeleteDialog}
            onClose={handleCloseDeleteDialog}
            fullWidth
            maxWidth="xs"
          >
            <DialogTitle sx={{ pb: 1 }}>
              <Typography variant="h6" fontWeight="600">
                Confirm Deletion
              </Typography>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
              <Typography>
                Are you sure you want to delete the product:{" "}
                <strong>{productToDelete?.name}</strong>?
              </Typography>
              <FormControl fullWidth sx={{ mt: 3 }}>
                <InputLabel id="delete-scope-label">Deletion Scope</InputLabel>
                <Select
                  labelId="delete-scope-label"
                  value={deleteScope}
                  label="Deletion Scope"
                  onChange={(e) => setDeleteScope(e.target.value)}
                >
                  <MenuItem value="this_branch">Delete from this branch</MenuItem>
                  <MenuItem value="all_branches">
                    Delete from all branches
                  </MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
            <Divider />
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={handleCloseDeleteDialog}
                sx={{ color: "#64748b" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                color="error"
                disabled={deleteLoading}
                startIcon={
                  deleteLoading ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : (
                    <DeleteIcon />
                  )
                }
              >
                {deleteLoading ? "Deleting..." : "Delete"}
              </Button>
            </DialogActions>
          </StyledDialog>

          <Snackbar
            open={toast.open}
            autoHideDuration={4000}
            onClose={() => setToast({ ...toast, open: false })}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={() => setToast({ ...toast, open: false })}
              severity={toast.severity}
              variant="filled"
              sx={{ width: "100%" }}
            >
              {toast.message}
            </Alert>
          </Snackbar>
        </Container>
      </IonContent>
    </IonPage>
  );
};

export default ProductSetupPage_all_branch;
